// Money
export const parseMoney = (value) => {
  if (typeof value === 'number') return value
  if (value == null) return 0
  let s = String(value).trim()

  s = s.replace(/[^\d,.\-]/g, '')

  if (s.includes(',') && s.includes('.')) {
    s = s.replace(/\./g, '')
    s = s.replace(',', '.')
  } else if (s.includes(',')) {
    s = s.replace(',', '.')
  }
  const n = parseFloat(s)
  return Number.isFinite(n) ? n : 0
}
